module.exports = __webpack_public_path__ + "img/17_109.66bab1b1.png";